import React from 'react';
import { Tooltip, styled } from '@mui/material';
import { Chip } from '@mui/material';
import { getAsLongDateTime } from '../../../../common-client2/src/services/ukgDateTime';
import {
    RequestTypes, RequestSubtypes,
} from '../../../Enums'
import './RequestTypeChip.scss';

const getChipClass = (request) => {
    switch (request.actionType) {
        case RequestTypes.toCover:
            return 'chip-tc';
        case RequestTypes.shiftSwap:
            return 'chip-ss';
        case RequestTypes.openShift:
            return 'chip-os';
        case RequestTypes.voluntaryTimeOff:
            return 'chip-vto';
        default:
            return 'chip-formatting';
    }
}
const getTooltip = (request) => {
    let content;
    switch (request.actionType) {
        case RequestTypes.toCover:
            content = 'To cover';
            break;
        case RequestTypes.shiftSwap:
            content = 'Shift swap';
            break;
        case RequestTypes.openShift:
            if (request?.requestSubtype === RequestSubtypes.signUp) {
                content = (
                    <div className='tooltip-text'>
                        <div> Open shift sign-up request </div>
                        <div> Submission start date/time:  {getAsLongDateTime(request.submissionPeriod_StartDate)} </div>
                        <div> Submission end date/time:  {getAsLongDateTime(request.submissionPeriod_EndDate)}</div>
                    </div>
                );
                break;
            }
            content = 'Fill open shift';
            break;
        case RequestTypes.voluntaryTimeOff:
            content = (
                <div className='tooltip-text'>
                    <div> Voluntary time-off request </div>
                    <div> Submission start date/time: {getAsLongDateTime(request.submissionPeriod_StartDate)} </div>
                    <div> Submission end date/time:  {getAsLongDateTime(request.submissionPeriod_EndDate)}</div>
                </div>
            );
            break;
        default:
            content = '';
    }
    return (
        <div className='tooltip-text'>
            {content}
        </div>);
}
const WarnTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: 'white',
        color: '#3A3A3A',
        maxWidth: '520px',
        border: '1px solid #dadde9',
    },
});

const RequestTypeChip = ({ request }) => {

    return (
        <React.Fragment>
            <WarnTooltip
                title={getTooltip(request)}
            >
                <Chip className={getChipClass(request)} label={request.requestType}></Chip>
            </WarnTooltip>
        </React.Fragment>
    );
}

export default RequestTypeChip;
